// This icon file is generated by scripts/icons/build.ts
// DON NOT EDIT IT MANUALLY

/* eslint-disable */
// @ts-ignore

import * as React from 'react';
import factory from '../factory';

export default factory(
  'HelpOutline',
  'help-outline',
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      d="M13.88 8A5.87 5.87 0 112.13 8a5.87 5.87 0 0111.75 0zM15 8A7 7 0 111 8a7 7 0 0114 0zm-7-.63A1.13 1.13 0 106.9 6c-.03.14-.14.25-.28.25H6c-.14 0-.25-.11-.24-.25a2.25 2.25 0 112.62 2.47v1.78c0 .14-.12.25-.26.25H7.5a.25.25 0 01-.25-.25V8.17a.8.8 0 01.75-.8zm-.88 4.57a.69.69 0 111.38 0 .69.69 0 01-1.38 0z"
      clipRule="evenodd"
    ></path>
  </svg>
);
